function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-131.074)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(132.317)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.335.021A.3.3,0,0,0,167.191,0H162.72a.617.617,0,0,0-.615.615.26.26,0,0,0,.021.123l.472,2.5h4.717l.492-2.5A.609.609,0,0,0,167.335.021Z",
  transform: "translate(-162.105)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(131.074 4.061)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M139.434,111.98l-1.948-10.6H132.85l-1.764,10.6a.586.586,0,0,0,.164.533L134.716,116a.613.613,0,0,0,.861.021l3.671-3.487A.62.62,0,0,0,139.434,111.98Z",
  transform: "translate(-131.074 -101.376)"
}))));

var SvgTie = function SvgTie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.371,
    height: 18.872,
    viewBox: "0 0 8.371 18.872",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tie.0721b067.svg";
export { ForwardRef as ReactComponent };